import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "../../../stores/LanguageStore";
import { getQuickCampaigns } from "../../../api/StatsAPI";
import { Group, Select, Tooltip } from "@mantine/core";
import { status_list } from "../../../pages/protected/leadsTracking/utils";
import Selector from "../../Selectors/Selector";
import { usePrmStore } from "../../../stores/PrmStore";
import {
  IconArchive,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerStop,
} from "@tabler/icons-react";

const FilterLeadsCampaign = ({ setValue, value, isMobile, readOnly }) => {
  const lang = useLanguage((s) => s.language);
  const options = usePrmStore((s) => s.campaignOptions);

  const [status, setStatus] = useState(
    value
      ? status_list().find((x) => x.value === value.split("_")[0])?.value
      : null
  );
  const [programmation, setProgrammation] = useState(
    value ? options.find((x) => x.id === parseInt(value.split("_")[1])) : null
  );

  const [loading, setLoading] = useState(false);

  const getOptions = () => {
    setLoading(true);
    getQuickCampaigns().finally(() => setLoading(false));
  };

  const handleStatusChange = (v) => {
    setStatus(v);
  };

  const handleProgrammationChange = (v) => {
    setProgrammation(v);
  };

  const progOptions = useMemo(() => {
    return [
      {
        label: "Programmations",
        options: options.map((x) => ({
          ...x,
          option_name: `${x.workflow_name} #${x.id}`,
        })),
      },
    ];
  }, [options]);

  useEffect(() => {
    if (status && programmation) {
      let result = status + "_" + programmation?.id;

      setValue(result);
    }
  }, [status, programmation, setValue]);

  return (
    <Group gap={"xs"}>
      <Select
        data={status_list()}
        value={status}
        placeholder={lang.table.toolbar.filter.values.campaign_status}
        required
        onChange={handleStatusChange}
        w={isMobile ? "100%" : undefined}
      />

      <Selector
        options={progOptions}
        loading={loading}
        value={programmation?.id || null}
        onChange={handleProgrammationChange}
        placeholder={lang.table.toolbar.filter.values.campaign}
        required
        getOptionName={(o) => o["workflow_name"] + " #" + o.id}
        onDropdownOpen={getOptions}
        rightOptionSection={(item) => {
          return (
            <Group wrap="nowrap" w={"100%"} justify="end" gap={8}>
              {item?.id && (
                <span style={{ fontSize: 10, opacity: 0.35 }}>#{item?.id}</span>
              )}
              {item?.stopped || item?.archived ? (
                <Tooltip
                  label={`${lang.statistics.filters.paused}${
                    item?.archived
                      ? ` - ${lang.workflows.program.step_exclusion.columns.archived.true}`
                      : ""
                  }`}
                >
                  <IconPlayerStop
                    size={12}
                    color={item?.archived ? "purple" : "red"}
                  />
                </Tooltip>
              ) : (
                <Tooltip label={lang.statistics.filters.running}>
                  <IconPlayerPlay size={12} color="green" />
                </Tooltip>
              )}
            </Group>
          );
        }}
        unclearable
        size={"sm"}
        readOnly={readOnly}
      />
    </Group>
  );
};

export default FilterLeadsCampaign;
